export default "__VITE_ASSET__djYs2gVp__"